import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=396fd93c"
import script from "./CatalogList.vue?vue&type=script&lang=ts"
export * from "./CatalogList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports